<div
  class="content-card course-card has-hidden-buttons body-over-media"
  tabindex="0"
  [ngClass]="'bundle-' + data.bundle"
  [class.locked]="data.isLocked"
  [class.extended]="extended"
  [class.disabled]="!data.active"
  [attr.data-cy]="data.bundle + '-card-' + data.id"
  (click)="cardClick.emit($event)">
  <div class="content-card__media" [class.media-21-9]="courseImageRatio === '21:9'">
    <div class="content-card__media--image"
      [placeholderImage]="!data?.mediaImage && data.bundle"
      [cropImage]="(data?.mediaImage | preSignedUrl | async) || data.image"
      [crop]="data.mediaImage?.crop"
      imageWidth="400">
    </div>
    <div class="content-card__badges" (click)="$event.stopPropagation()">
      @if (data.isLocked) {
        <div
          class="content-card__badges--item badge-dark"
        [matTooltip]="data.selectiveLockingItems?.length
          ? ('COMMON.selective_locked_list' | translate:{content: selectiveLockingItems})
          : ('ERRORS.content_locked' | translate)">
          <lib-icon icon="lock-simple" [size]="16"></lib-icon> {{'MODULE_LESSON_CARD.locked' | translate}}
        </div>
      }
      @if (data.isNew && data?.progress !== 100) {
        <div class="content-card__badges--item badge-blue">
          {{'COMMON.new' | translate}}
        </div>
      }
      @if (data.nonMandatory) {
        <div class="content-card__badges--item badge-orange">
          <mat-icon svgIcon="lms-branch"></mat-icon> {{'COMMON.optional' | translate | titlecase}}
        </div>
      }
    </div>
  </div>
  <div class="content-card__body">
    @if (showType) {
      <div class="content-card__body--label">
        <div class="content-card__body--label-item text-uppercase">
          {{ data | bundleLabel | async }}
        </div>
      </div>
    }
    <div class="content-card__body--title">{{data.title}}</div>
    <div class="content-card__body--footer flex-nowrap align-items-end justify-content-between">
      <div class="content-card__body--footer-list">
        @if (!data.progress || data.progress !== 100) {
          @if (data.payable && !data.isPaid && paymentEnabled && cardsSettings?.[data.bundle]?.price?.visible) {
            <div [style.order]="cardsSettings?.[data.bundle]?.price?.weight" class="content-card__body--footer-item">
              <div class="content-card__price">{{data.price}} {{data.currency | uppercase}}</div>
            </div>
          }
          @if (data.progress && !hideProgress) {
            <div class="content-card__body--footer-item progress-indicator" [style.order]="cardsSettings?.[data.bundle]?.progress?.weight">
              @if (data.progress !== 1) {
                <mat-progress-bar class="default-theme" aria-label="Progress" mode="determinate" [value]="data.progress" data-cy="card-progress-bar"></mat-progress-bar> {{data.progress}}%
              } @else {
                <lib-icon icon="circle-dashed" [size]="16"></lib-icon> {{'COMMON.in_progress' | translate}}
              }
            </div>
          }
          @if (cardsSettings?.[data.bundle]?.content?.visible) {
            @if (skipModule || data.bundle === bundleTypes.MODULE) {
              @if (data.lessonsCount) {
                <div class="content-card__body--footer-item" [style.order]="cardsSettings?.[data.bundle]?.content?.weight">
                  <lib-icon icon="stack" [size]="16"></lib-icon> {{'COMMON.lessons_count' | translate:{count: data.lessonsCount} }}
                </div>
              }
            } @else {
              @if (data.modulesCount) {
                <div class="content-card__body--footer-item" [style.order]="cardsSettings?.[data.bundle]?.content?.weight">
                  <lib-icon icon="stack" [size]="16"></lib-icon> {{'COMMON.n_modules' | translate:{count: data.modulesCount} }}
                </div>
              }
            }
          }
          @if (data.time && cardsSettings?.[data.bundle]?.time?.visible) {
            <div class="content-card__body--footer-item" [style.order]="cardsSettings?.[data.bundle]?.time?.weight">
              <lib-icon icon="clock" [size]="16"></lib-icon> {{data.time | minutesToTime : 'short' }}
            </div>
          }
          @if (data.leaderboardPoints && leaderboardEnabled && cardsSettings?.[data.bundle]?.leaderboardPoints?.visible) {
            <div [style.order]="cardsSettings?.[data.bundle]?.leaderboardPoints?.weight" [matTooltip]="'COMMON.content_complete_points' | translate:{points: data.leaderboardPoints}" class="content-card__body--label-item">
              <lib-icon icon="currency-eth" [size]="16"></lib-icon> {{data.leaderboardPoints}} {{'LEADERBOARD.pts' | translate | lowercase}}
            </div>
          }
          @if (data.achievements?.length && achievementsEnabled && cardsSettings?.[data.bundle]?.achievements?.visible) {
            <div [matTooltip]="'COMMON.content_complete_achievements' | translate:{count: data.achievements?.length, content: achievementsTitle}" class="content-card__body--label-item" [style.order]="cardsSettings?.[data.bundle]?.achievements?.weight">
              <lib-icon icon="medal" [size]="16"></lib-icon> {{'COMMON.achievement' | translate}}
            </div>
          }
          @if (data.certifications?.length && certificatesEnabled && cardsSettings?.[data.bundle]?.certificate?.visible) {
            <div [matTooltip]="'COMMON.content_complete_certificate' | translate:{ certificate: certificationsTitle }" class="content-card__body--label-item" [style.order]="cardsSettings?.[data.bundle]?.certificate?.weight">
              <lib-icon icon="certificate" [size]="16"></lib-icon> {{'COMMON.certificate' | translate}}
            </div>
          }
        } @else {
          <div class="content-card__body--footer-item completed-indicator">
            <lib-icon icon="check-circle" [fill]="true"></lib-icon> {{'MODULE_LESSON_CARD.completed' | translate}}
          </div>
        }

      </div>
      <ng-container *ngNativeAppConditionalVisibility="false">
        @if (availableForDownload) {
          <div class="content-card__body--footer-download">
            <button mat-icon-button [matTooltip]="statusLabel?.text | translate" aria-label="Download for offline use" (click)="offlineDownloadHandler($event)">
              @if (status !== OfflineDownloadStatusEnum.IN_PROGRESS) {
                <lib-icon [icon]="statusLabel?.icon"></lib-icon>
              }
              @if (status === OfflineDownloadStatusEnum.IN_PROGRESS) {
                <div class="d-flex align-items-center justify-content-center">
                  <mat-spinner [diameter]="16"></mat-spinner>
                </div>
              }
            </button>
          </div>
        }
      </ng-container>
    </div>
    <div class="content-card__body--hidden">
      @if (!data.isLocked) {
        <button (click)="buttonClickEmitter($event)" mat-flat-button class="button button--primary">
          @if (data.payable && !data.isPaid && paymentEnabled) {
            <lib-icon icon="shopping-cart"></lib-icon>
            <span>{{'COMMON.buy' | translate}} {{data.price}} {{data.currency | uppercase}}</span>
          } @else {
            <lib-icon [icon]="data.progress === 100 ? 'arrow-clockwise' : 'play'"></lib-icon>
            @if (data.progress === 100) {
              {{'COMMON.start_again' | translate}}
            }
            @if (data.progress && data.progress !== 100) {
              {{'COMMON.continue' | translate}}
            }
            @if (!data.progress) {
              {{'COMMON.start' | translate}}
            }
          }
        </button>
      }
      @if (showDetailsButton && data.bundle === bundleTypes.COURSE) {
        <button (click)="detailsClickEmitter($event)" mat-button class="button button--icon button--transparent info-button" [attr.aria-label]="'COMMON.more_information' | translate">
          <lib-icon icon="info"></lib-icon>
        </button>
      }
    </div>
  </div>
</div>
